import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar } from '../../../../global/commonStyle';

const Group = styled.div`
  max-width: 503px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: var(--space-20) var(--space-24) var(--space-24);
  gap: var(--space-16);
  ${mobile_xl(css`
    padding: var(--space-8) var(--space-20) var(--space-96);
  `)}
`;
const Title = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;

const ModalBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;
const Searchbar = styled.div`
  padding-inline: var(--space-16);
`;

const Members = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 176px;
  white-space: nowrap;
  ${HideScrollbar}
`;

const Profile = styled.div`
  ${AlignCenter}
  padding: var(--space-8) var(--space-16);
  gap: var(--space-20);
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    width: calc(100% - 32px);
  `)}
`;

const Name = styled.div`
  width: 330px;
  ${AlignCenter}
  gap: var(--space-10);
  p {
    ${Typography.body_md_medium}
    text-align: right;
    margin: var(--space-0);
    color: var(--text-primary);
  }
`;

const Check = styled.div`
  display: flex;
  gap: var(--space-10);
  input[type='checkbox']:disabled {
    background-color: var(--background-muted);
    opacity: 1;
    border: 1px solid var(--background-muted);
  }

  input[type='checkbox']:disabled::before {
    content: '';
    position: absolute;
    right: 50%;
    top: 50%;
    width: 4px;
    height: 10px;
    border: solid var(--text-placeholder);
    border-width: 0 2px 2px 0;
    margin: -1px -1px var(--space-0) -1px;
    -webkit-transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    -ms-transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    z-index: var(--z-index-base);
  }
`;

const Invite = styled.div`
  ${Typography.body_md_medium}
  text-decoration: none;
  list-style: none;
  color: var(--brand-primary);
  padding-block: var(--space-16);
  text-align: center;
  cursor: pointer;
  border-top: 0.5px solid var(--border-primary);
`;

export { Group, Title, ModalBlock, Members, Profile, Name, Check, Invite, Searchbar };
